import classNames from 'classnames';
import { ClipLoader } from 'react-spinners';
import SVGIcon, { IIcons } from './icons';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	loading?: boolean;
	theme?: 'default' | 'light' | 'red';
	icon?: IIcons;
}

const Button = ({
	children,
	className,
	type = 'button',
	disabled,
	loading,
	icon,
	theme = 'default',
	...props
}: ButtonProps) => {
	const buttonTheme = {
		default:
			'text-white bg-primary hover:bg-primary-dark border-primary disabled:bg-gray disabled:border-gray',
		light: 'text-primary bg-white hover:bg-gray-bg border-primary ',
		red: 'text-white bg-red hover:bg-red-dark border-red',
	}[theme];

	return (
		<button
			disabled={disabled || loading}
			className={classNames(
				'px-3 justify-center rounded-md transition-colors border font-semibold flex items-center gap-3 disabled:pointer-events-none',
				{
					'py-2': !className?.includes('py-'),
				},
				buttonTheme,
				className
			)}
			type={type}
			{...props}
		>
			{loading ? (
				<ClipLoader
					className={classNames({ hidden: !loading })}
					size="1.25rem"
					color="white"
				/>
			) : (
				<>
					{icon && <SVGIcon className="h-4 w-auto" icon={icon} />}
					{children}
				</>
			)}
		</button>
	);
};

export default Button;
